import { ArrowLeftIcon, CancelIcon, ExclamationMarkIcon } from "@ala/icons/symbols/solid";

import { ModalIds } from "../../constants";
import { ConfirmationModal } from "../confirmation-modal/confirmation-modal";
import { modalWithArgs } from "./modal-builder";
import { useModalConfirmOperations } from "./operations/use-modal-confirm-operations";
import { useRouteModalsStore } from "./route-modals.store";
import { useUserTriggeredModalsStore } from "./user-triggered-modals.store";

const DEFAULT_PROPS = {
  title: "Unsaved changes",
  description: "Confirm navigation",
  content: "You have unsaved changes. If you leave now, your changes will be lost.",
  submitText: "Leave",
  submitIcon: <CancelIcon />,
  cancelText: "Stay",
  cancelIcon: <ArrowLeftIcon />,
  variant: "red" as const,
  icon: (
    <>
      <div className="absolute top-1/2 left-1/2 size-6 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white" />
      <ExclamationMarkIcon className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
    </>
  ),
};

export const CloseConfirmationModal = modalWithArgs(
  ModalIds.CLOSE_CONFIRMATION,
  (_, args: { triggererId?: string; isRouteModal?: boolean }) => {
    const { behaviorOptions } = useUserTriggeredModalsStore();
    const routeBehaviorOptions = useRouteModalsStore((state) => state.behaviorOptions);
    const { confirmAndDismissAll } = useModalConfirmOperations();

    const getBehavior = () => {
      if (args.isRouteModal) return routeBehaviorOptions;
      if (args.triggererId) return behaviorOptions[args.triggererId];
    };

    const behavior = getBehavior();

    return (
      <ConfirmationModal
        onSubmit={() => {
          confirmAndDismissAll(args);
          return { shouldKeepModalOpen: true };
        }}
        {...DEFAULT_PROPS}
        {...behavior?.closeConfirmationProps}
      />
    );
  },
);
